import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomerPhotoComponent } from './customer-photo.component';
import { CustomerSignatureComponent } from './customer-signature.component';

@NgModule({
    declarations: [
        CustomerPhotoComponent,
        CustomerSignatureComponent
    ],
    providers: [
    ],
    imports: [
        CommonModule
    ],
    exports: [
        CustomerPhotoComponent,
        CustomerSignatureComponent
    ]
})

export class CustomerImageModule {
}
